import protoRoot from "../proto-root";
import createMessage from "./createMessage";

const name = "cloudAccountSyncMessage";

function create({ item }) {
  const CloudAccountSyncMessage = protoRoot.lookupType(
    "comm.CloudAccountSyncMessage"
  );
  const CloudAccountSyncItem = CloudAccountSyncMessage.lookupEnum(
    "CloudAccountSyncItem"
  );

  const cloudAccountSyncMessage = CloudAccountSyncMessage.create({
    item: CloudAccountSyncItem.values[item]
  });

  return createMessage({ [name]: cloudAccountSyncMessage });
}

export default {
  create,
  name
};

// message CloudAccountSyncMessage {
//   enum CloudAccountSyncItem {
//       ALL = 0;
//       CLOUD_ACCOUNT = 1;
//       AVATARS = 2;
//       COMMANDS = 3;
//       LULLABIES = 4;
//       CLOUD_SETTINGS = 5;
//       DEVICES = 6;
//   }
//   CloudAccountSyncItem item = 1;
// }
